import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { useEffect, useState } from "react";
import { getReceiptFooterData } from "../helper";

const RaiseInvoicePdfFooterView = (props) => {
  const { receiptPdfData } = props;

  const styles = StyleSheet.create({
    invoiceFooterContainer: {
      borderTop: "1px solid #E1E1E1",
      padding: "0px 22px",
      paddingTop: "10px",
    },
    invoiceFooterContent: {
      display: "flex",
      flexDirection: "row",
    },
    invoiceFooterLeftContent: {
      width: "70%",
    },
    invoiceFooterRightContent: {
      width: "30%",
      display: "flex",
      flexDirection: "column",
      textAlign: "right",
      alignItems: "flex-end",
    },
    invoiceFooterHospitalDetails: {
      fontFamily: "notosans",
      fontWeight: "normal",
      fontSize: "8px",
    },
    invoiceFooterHospitalDetailsTitle: {
      fontWeight: "500",
    },
    footerHospitalLogo: {
      width: "30px",
      height: "30px",
    },
    footerPoweredByContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      textAlign: "right",
      justifyContent: "flex-end",
      marginTop: "5px",
    },
    footerPoweredByTitle: {
      fontFamily: "notosans",
      fontWeight: "normal",
      fontSize: "7px",
    },
    footerC2CLogo: {
      width: "40px",
      height: "20px",
    },
    footerDefaultMsgContainer: {
      display: "flex",
      flexDirection: "row",
      marginTop: "8px",
    },
    footerDefaultMsg: {
      display: "flex",
      flexDirection: "row",
      alignItems: "end",
      fontFamily: "notosans",
      fontWeight: "normal",
      fontSize: "8px",
      marginBottom: "5px",
      fontStyle: "italic",
    },
    footerDefaultMsgRightContainer: {
      width: "45%",
      display: "flex",
      flexDirection: "column",
      textAlign: "right",
      alignItems: "flex-end",
    },
    footerSignatureMsg: {
      fontFamily: "notosans",
      fontWeight: "normal",
      fontSize: "8px",
      fontStyle: "italic",
    },
    footerDefaultMsgLeftContainer: {
      width: "55%",
    },
    invoiceFooterClinicListContent: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      marginBottom: "10px",
    },
    invoiceFooterHospitalDetailsContent: {
      marginBottom: "5px",
    },
    clinicInvoiceFooterHospitalDetailsTitle: {
      fontWeight: "500",
      marginBottom: "3px",
    },
  });

  const [receiptFooterData, setReceiptFooterData] = useState({});

  // Lifecycle Methods ===>

  useEffect(() => {
    if (Object?.keys(receiptPdfData)?.length > 0) {
      setReceiptFooterData({ ...receiptPdfData?.payload_reciept });
    }
  }, [receiptPdfData]);

  // <===

  const displayHospitalLogo = () => {
    return (
      <>
        {receiptFooterData?.receiptFooterData?.hospitalLogo !== "" && (
          <Image
            src={receiptFooterData?.receiptFooterData?.hospitalLogo}
            alt=""
            style={styles.footerHospitalLogo}
          />
        )}
      </>
    );
  };

  const displayPoweredByUI = () => {
    return (
      <View style={styles.footerPoweredByContainer}>
        <Text style={styles.footerPoweredByTitle}>Powered by&nbsp;</Text>
        <Image
          src={receiptFooterData?.receiptFooterData?.c2cLogo}
          alt="Connect2Clinic"
          style={styles.footerC2CLogo}
        />
      </View>
    );
  };

  const displayInvoiceFooterView = () => {
    return (
      <View style={styles.invoiceFooterContainer}>
        {receiptFooterData?.receiptFooterData?.show_hospital_footer ? (
          <>
            {receiptFooterData?.receiptFooterData?.is_clinic_found ? (
              <View style={styles.invoiceFooterContent}>
                <View style={styles.invoiceFooterLeftContent}>
                  {receiptFooterData?.receiptFooterData?.doctor_hospital_details
                    ?.is_hospital_name_enabled ? (
                    <View style={styles.invoiceFooterHospitalDetails}>
                      <Text style={styles.invoiceFooterHospitalDetailsTitle}>
                        Registered Office:
                      </Text>
                      <Text style={styles.invoiceFooterHospitalDetailsContent}>
                        {
                          receiptFooterData?.receiptFooterData
                            ?.doctor_hospital_details?.hospital_name
                        }
                      </Text>
                    </View>
                  ) : null}
                  {receiptFooterData?.receiptFooterData?.doctor_hospital_details
                    ?.is_hospital_address_enabled ? (
                    <View style={styles.invoiceFooterHospitalDetails}>
                      <Text style={styles.invoiceFooterHospitalDetailsTitle}>
                        Address:
                      </Text>
                      <Text style={styles.invoiceFooterHospitalDetailsContent}>
                        {
                          receiptFooterData?.receiptFooterData
                            ?.doctor_hospital_details?.hospital_address
                        }
                      </Text>
                    </View>
                  ) : null}
                  {receiptFooterData?.receiptFooterData?.doctor_hospital_details
                    ?.is_hospital_contact_no_enabled &&
                  receiptFooterData?.receiptFooterData?.doctor_hospital_details
                    ?.hospital_contact_number !== "" ? (
                    <View style={styles.invoiceFooterHospitalDetails}>
                      <Text style={styles.invoiceFooterHospitalDetailsTitle}>
                        Contact No:
                      </Text>
                      {receiptFooterData?.receiptFooterData
                        ?.doctor_hospital_details?.hospital_contact_number !==
                      "" ? (
                        <Text
                          style={styles.invoiceFooterHospitalDetailsContent}
                        >
                          {
                            receiptFooterData?.receiptFooterData
                              ?.doctor_hospital_details?.hospital_contact_number
                          }
                        </Text>
                      ) : null}
                    </View>
                  ) : null}
                </View>
                <View style={styles.invoiceFooterRightContent}>
                  {receiptFooterData?.receiptFooterData
                    ?.is_hospital_logo_enabled ? (
                    <>
                      {displayHospitalLogo()}
                      {displayPoweredByUI()}
                    </>
                  ) : null}
                </View>
              </View>
            ) : null}
          </>
        ) : null}

        {/* <!-- Individual footer start --> */}

        {receiptFooterData?.receiptFooterData
          ?.is_default_c2c_footer_to_be_shown_in_receipt &&
        receiptFooterData?.receiptFooterData?.is_clinic_found ? (
          <View style={styles.invoiceFooterContent}>
            <View style={styles.invoiceFooterLeftContent}>
              {receiptFooterData?.receiptFooterData?.doctor_hospital_details.map(
                (item, ind) => (
                  <View style={styles.invoiceFooterHospitalDetails} key={ind}>
                    <Text
                      style={styles.clinicInvoiceFooterHospitalDetailsTitle}
                    >
                      Clinic/Hospitals Details {ind + 1}:
                    </Text>
                    <View style={styles.invoiceFooterClinicListContent}>
                      {item?.is_hospital_name_enabled ? (
                        item?.hospital_name !== "" ? (
                          <Text>{item?.hospital_name} |</Text>
                        ) : null
                      ) : null}
                      {item?.is_hospital_address_enabled ? (
                        item?.hospital_address !== "" ? (
                          <Text>{item?.hospital_address} |</Text>
                        ) : null
                      ) : null}
                      {item?.is_hospital_contact_no_enabled ? (
                        item?.hospital_contact_number !== "" ? (
                          <Text>
                            Contact No:{item?.hospital_contact_number}
                          </Text>
                        ) : null
                      ) : null}
                      {item?.is_hospital_timings_enabled ? (
                        item?.hospital_timings !== "" ? (
                          <Text>{item?.hospital_timings}</Text>
                        ) : null
                      ) : null}
                    </View>
                  </View>
                )
              )}
            </View>
            <View style={styles.invoiceFooterRightContent}>
              {receiptFooterData?.receiptFooterData
                ?.is_hospital_logo_enabled ? (
                <>
                  {displayHospitalLogo()}
                  {displayPoweredByUI()}
                </>
              ) : null}
            </View>
          </View>
        ) : null}

        {/* <!-- Individual footer end -->   */}

        <View style={styles.footerDefaultMsgContainer}>
          <View style={styles.footerDefaultMsgLeftContainer}>
            <Text style={styles.footerDefaultMsg}>
              *Service exempt vide Serial No 74 of Notification 12/2017-CT(Rate)
            </Text>
            {receiptFooterData?.receiptFooterData?.created_by !== "" ? (
              <Text style={styles.footerSignatureMsg}>
                This is computer generated receipt no signature required
              </Text>
            ) : null}
          </View>

          <View style={styles.footerDefaultMsgRightContainer}>
            {receiptFooterData?.receiptFooterData?.showC2CLogo ? (
              <View style={styles.invoiceFooterRightContent}>
                {displayPoweredByUI()}
              </View>
            ) : null}

            <Text style={styles.footerSignatureMsg}>
              {receiptFooterData?.receiptFooterData?.created_by !== ""
                ? `Created By: ${receiptFooterData?.receiptFooterData?.created_by}`
                : "This is computer generated receipt no signature required"}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  return (
    <View>
      {Object.keys(receiptFooterData)?.length > 0 && displayInvoiceFooterView()}
    </View>
  );
};

export default RaiseInvoicePdfFooterView;
